module.exports = __webpack_public_path__ + "media/images/icon/icon-twitter-fe672601a1f1bdff65ce68c6e1f503f5.svg";